import {ROUTES} from "../../constants";

export const DEMO_CARDS = [
    {
        name: 'Real Time Assist',
        subtitle:'Instant, context-relevant assist on live calls',
        disabled: false,
        testButton: {
            redirectPath: ROUTES.REAL_TIME_ASSIST,
            disable: false
        },
        deployButton: {
            redirectPath: null,
            disable: true
        },
        documentationLink: `https://docs.symbl.ai/docs/building-real-time-assist-for-automated-recommendations-during-live-conversations#components`
    },
    {
        name: 'Call Score',
        subtitle:'Evaluate participant performance based on your criteria',
        disabled: false,
        testButton: {
            redirectPath: ROUTES.CALL_SCORE,
            disable: false
        },
        deployButton: {
            redirectPath: null,
            disable: true
        },
        documentationLink: `https://docs.symbl.ai/docs/call-score`
    },
    // {
    //     name: 'Real Time Chatbot',
    //     disabled: false,
    //     testButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     deployButton: {
    //         redirectPath: null,
    //         disable: true
    //     },
    //     documentationLink: null
    // },
    {
        name: 'Admin Analytics',
        subtitle:'Get an aggregated view of team performance',
        disabled: true,
        testButton: {
            redirectPath: null,
            disable: true
        },
        deployButton: {
            redirectPath: null,
            disable: true
        },
        documentationLink: `https://docs.symbl.ai/docs/admin-analytics`
    }
]